var notificationsEllipsisInEnglish = [
    'autopayFutureNotify',
    'autopayTomorrowNotify',
    'loanApprovedStillProcessingNotify',
    'loanPaidOffNotify'
];
var notificationsEllipsisInSpanish = [
    'autopayFutureNotify',
    'autopayTomorrowNotify',
    'introRateLoanExpiringNotify',
    'loanApprovedStillProcessingNotify',
    'loanPaidOffNotify',
    'waivedInterestExpiringNotify'
];
export { notificationsEllipsisInEnglish, notificationsEllipsisInSpanish };
